import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { FilterService } from './filter.service';
import { ConsultService } from './consult.service';
import { UserService } from './user.service';
import { CatalogSectionService } from './catalog-section.service';
import { filter } from 'rxjs/operators';
import { COOKIE_DOMAIN, COOKIE_PATH, parseQuery } from './lib/helpers';
import { CookieService } from 'ngx-cookie';
import {CityService, City} from './city.service';
import {HttpClient} from '@angular/common/http';
import { SeoService } from './seo.service';

@Component({
  selector: 'app-root',
  templateUrl: '../templates/app.component.html',
  styleUrls: ['../styles/components/app.component.less']
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private location: Location,
    private filterService: FilterService,
    private consultService: ConsultService, // speed up service initialization
    private userService: UserService, // speed up service initialization
    private sectionService: CatalogSectionService,
    private cookie: CookieService,
    public cityService: CityService,
    private http: HttpClient,
    private seoService: SeoService,
  ) {
    // scroll to top of page
    this.router.events.pipe(
      filter((e: Event) => e instanceof NavigationEnd)
    ).subscribe(() => {
      if (typeof window !== 'undefined') window.scroll(0, 0);
    });
  }

  public ngOnInit() {
    this.seoService.createLinkForCanonicalURL();

    this.router.events.subscribe(() => {
      if(typeof window !== 'undefined'){
        this.seoService.createLinkForCanonicalURL();
      }
    });
    if (typeof window !== 'undefined') {
      const queryParams = parseQuery(this.location.path());
      if (queryParams.target) {
        this.cookie.put('target', queryParams.target, {
          expires: new Date(Date.now() + (10 * 24 * 60 * 60 * 1000)),
          path: COOKIE_PATH,
          domain: COOKIE_DOMAIN
        });
      }
      if (queryParams.activity) {
        this.cookie.put('activity', queryParams.activity, {
          expires: new Date(Date.now() + (10 * 24 * 60 * 60 * 1000)),
          path: COOKIE_PATH,
          domain: COOKIE_DOMAIN
        });
      }


      this.http.get('https://api.sypexgeo.net/json/').subscribe(async res => {
        // @ts-ignore
        const foreignApiCity = res.city.name_ru;
        let cityFromRequest: City;
        const currentCityCookie = this.cookie.get('city');
        if (currentCityCookie) {
          cityFromRequest = await this.cityService.get({
              filter: {CODE: currentCityCookie}
          }
          ).then(cities => cities[0]);
        } else {
          const city = await this.cityService.get({
              filter: {NAME: foreignApiCity}
            }
          ).then(cities => cities[0]);
          if (city) { cityFromRequest = city; }
        }
        if (cityFromRequest.NAME) {
          this.consultService.notifications.push({
            name: `Вы в ${cityFromRequest.PROPERTY_INFLECTED_VALUE}?`,
            status: 'danger',
            buttons: [
              {
                text: 'Да',
                click: () => {
                    this.cityService.city = cityFromRequest;
                    this.cookie.put('city', cityFromRequest.CODE, {
                        expires: new Date(Date.now() + (30 * 24 * 60 * 60 * 1000)),
                        path: COOKIE_PATH,
                        domain: COOKIE_DOMAIN
                      }
                    );
                  },
                ngclass: {
                  'uk-button': true,
                  'uk-button-primary': true,
                  'uk-float-left': true,
                },
                customAttr: {
                  ukToggle: 'target: #LeftMenu_Item_ConsultWindow'
                }
              },
              {
                text: 'Нет',
                ngclass: {
                  'uk-button': true,
                  'uk-button-secondary': true,
                  'uk-float-right': true,
                },
                customAttr: {
                  ukToggle: 'target: #ModalCitySelect'
                }
              }
            ],
            createdAt: (new Date()).toISOString(),
            isReaded: false
          });
        }
      });
    }

    this.filterService.changeActive.subscribe((target: any) => {
      const targetArr: string[] = [];
      if (this.filterService.activeTargetAudience) targetArr.push(this.filterService.activeTargetAudience._id);
      if (this.filterService.activeActivity) targetArr.push(this.filterService.activeActivity._id);
      this.sectionService.updateSections(targetArr);
    });
  }
}
